import { IGoinzonesState, IStationUSerGoinzonesState } from '../../../types'
import {
  GET_GOINZONE_REQUEST,
  GET_GOINZONE_SUCCESS,
  GET_GOINZONE_FAIL,
  GET_GOINZONE_BY_LOCATION_REQUEST,
  GET_GOINZONE_BY_LOCATION_SUCCESS,
  GET_GOINZONE_BY_LOCATION_FAIL,
  CREATE_GOINZONE_REQUEST,
  CREATE_GOINZONE_SUCCESS,
  CREATE_GOINZONE_FAIL,
  REMOVE_GOINZONE_REQUEST,
  REMOVE_GOINZONE_SUCCESS,
  REMOVE_GOINZONE_FAIL,
  UPDATE_GOINZONE_REQUEST,
  UPDATE_GOINZONE_SUCCESS,
  UPDATE_GOINZONE_FAIL,
  SET_GOINZONE_VISIBLITY,
  STATION_USER_GET_GOINZONE_REQUEST,
  STATION_USER_GET_GOINZONE_SUCCESS,
  STATION_USER_GET_GOINZONE_FAIL,
  STATION_USER_EDIT_SET_FETCHING
} from 'src/state/constants'

const init: IStationUSerGoinzonesState = {
  isFetching: false,
  visible: false,
  items: {}
}

export function stationUserGoinzones(state: IStationUSerGoinzonesState, action: any): IStationUSerGoinzonesState {
  if (typeof state === 'undefined') {
    return init
  }
  switch (action.type) {
    case STATION_USER_GET_GOINZONE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case STATION_USER_GET_GOINZONE_SUCCESS:
      return Object.assign({}, state, {
        items: Object.assign({}, action.payload)
      })
    case STATION_USER_GET_GOINZONE_FAIL:
      return Object.assign({}, state, {
        isFetching: false
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/station-user-goin-zones/index.ts